import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/SupabaseAuthContext';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: ReactNode;
  requireFounder?: boolean;
}

const ProtectedRoute = ({ children, requireFounder = false }: ProtectedRouteProps) => {
  const { user, loading, isFounder, founderChecked } = useAuth();

  // 1. Show Spinner while deciding
  if (loading) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-maslow-cream">
        <Loader2 className="w-8 h-8 text-maslow-navy animate-spin" />
      </div>
    );
  }

  // 2. Not Logged In? -> Go to Login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 3. Founder route, but the founder check hasn't resolved yet? -> Wait.
  // Prevents redirecting on the initial false isFounder before checkFounderStatus
  // returns. Non-founder routes never wait on this (preserves the profile-page fix).
  if (requireFounder && !founderChecked) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-maslow-cream">
        <Loader2 className="w-8 h-8 text-maslow-navy animate-spin" />
      </div>
    );
  }

  // 4. Logged In but NOT Founder? -> Go to The Hull
  if (requireFounder && !isFounder) {
    return <Navigate to="/hull" replace />;
  }

  // 4. Access Granted
  return <>{children}</>;
};

export default ProtectedRoute;
